// src/components/Pgrooms.jsx
import React, { useEffect, useState } from "react";

const defaultImages = [
  "/images/gallery/21.jpg",
  "/images/gallery/22.jpg",
  "/images/gallery/23.jpg",
];

export default function Pgrooms({ images = defaultImages }) {
  const [idx, setIdx] = useState(null); // null = lightbox closed

  // Build {src,label} for each image (1/2/3 Sharing Room)
  const rooms = images.map((src, i) => ({
    src,
    label: `${i + 1} Sharing Room`,
  }));

  const openAt = (i, e) => {
    e?.preventDefault();
    setIdx(i);
  };
  const close = () => setIdx(null);
  const prev = (e) => {
    e?.stopPropagation();
    setIdx((i) => (i - 1 + rooms.length) % rooms.length);
  };
  const next = (e) => {
    e?.stopPropagation();
    setIdx((i) => (i + 1) % rooms.length);
  };

  useEffect(() => {
    if (idx === null) return;
    const onKey = (e) => {
      if (e.key === "Escape") close();
      if (e.key === "ArrowLeft") prev(e);
      if (e.key === "ArrowRight") next(e);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [idx, rooms.length]);

  return (
    <>
      <section
        className="page-title"
        style={{ backgroundImage: "url('/images/background/3.jpg')" }}
      >
        <div className="auto-container">
          <h1>Our Rooms</h1>
        </div>
      </section>

      <section className="gallery-section">
        <div className="auto-container">
          {/* Title */}
          <div className="faqs-title">
            <h3>
              Comfortable Living Spaces
              <br />
              Explore Your Home Away from Home
            </h3>
            <div className="separator"></div>
          </div>

          {/* Grid */}
          <div className="row g-3">
            {rooms.map((item, i) => {
              // With 3 items, you may prefer 3 per row on md+:
              // const colClass = "col-12 col-sm-6 col-md-4";
              const colClass = i < 4 ? "col-12 col-sm-6 col-md-6" : "col-12 col-sm-6 col-md-4";
              return (
                <div className={`${colClass} gallery-item`} key={item.src + i}>
                  <a
                    href={item.src}
                    className="plus-icon lightbox-image"
                    data-fancybox-group="gallery-one"
                    onClick={(e) => openAt(i, e)}
                  >
                    <div className="gallery-box room-card">
                      <span className="room-badge">{item.label}</span>
                      <div className="gallery-img">
                        <img src={item.src} alt={item.label} loading="lazy" />
                      </div>
                    </div>
                  </a>
                </div>
              );
            })}
          </div>
        </div>

        {/* Lightbox */}
        {idx !== null && (
          <div className="gx-lightbox" onClick={close} role="dialog" aria-modal="true">
            <button className="gx-close" onClick={close} aria-label="Close">
              ×
            </button>
            <button className="gx-prev" onClick={prev} aria-label="Previous">
              ‹
            </button>
            <img className="gx-img" src={rooms[idx].src} alt={rooms[idx].label} />
            <button className="gx-next" onClick={next} aria-label="Next">
              ›
            </button>
          </div>
        )}
      </section>
    </>
  );
}
